<div class="form-group container" id="partner-detail-detail-component" *ngIf="partner">
    <form #updatePartnerForm="ngForm">
        <div class="row">
            <div>
                <h1 *ngIf="type === 'update'">
                    <i class="fa fa-users" aria-hidden="true"></i>&nbsp;
                    {{partnerName}}
                </h1>
                <h1 *ngIf="type === 'create'">
                    <i class="fa fa-users" aria-hidden="true"></i>&nbsp;
                    {{'partners.pageHeaders.create' | translate}}</h1>
                <div style="margin-top:30px;">
                    <div>

                        <div class="plt-display-row col-md-12 plt-b-spaced">
                            <h3 style="margin-left: 30px">Paramètres de base</h3>
                        </div>
                        <div class="plt-display-row col-md-12 plt-b-spaced">
                            <div class="col-md-6">
                                <div class="col-md-3" style="margin-top:15px;">
                                    <label for="name" class="required">
                                        {{ 'partners.name' | translate}}
                                    </label>
                                </div>
                                <div class="col-md-9">
                                    <input type="text" class="form-control" id="name"
                                           required #name="ngModel" name="name"
                                           [(ngModel)]="partner.name">
                                </div>
                            </div>
                        </div>
                        <div class="plt-display-row col-md-12 plt-b-spaced">
                            <div class="col-md-6">
                                <div class="col-md-3" style="margin-top:15px;">
                                    <label for="technical-name" class="required">
                                        {{ 'partners.technicalName' | translate}}</label>
                                </div>
                                <div class="col-md-9">
                                    <input type="text" class="form-control" id="technical-name"
                                           #name="ngModel" name="technical-name"
                                           [(ngModel)]="partner.technicalName">
                                </div>
                            </div>
                        </div>
                        <div class="plt-display-row col-md-12 plt-b-spaced">
                            <div class="col-md-6">
                                <div class="col-md-3" style="margin-top:15px;">
                                    <label for="url" class="required">
                                        {{ 'partners.url' | translate}}</label>
                                </div>
                                <div class="col-md-9">
                                    <input type="text" class="form-control" id="url"
                                           #name="ngModel" name="url"
                                           [(ngModel)]="partner.url">
                                </div>
                            </div>
                        </div>
                        <div class="plt-display-row col-md-12 plt-b-spaced">
                            <div class="col-md-6">
                                <div class="col-md-3" style="margin-top:15px;">
                                    <label for="zipCode">{{ 'partners.order' | translate}}</label>
                                </div>
                                <div class="col-md-9">
                                    <input type="text" class="form-control" id="zipCode"
                                           #name="ngModel" name="zipCode"
                                           [(ngModel)]="partner.partnerOrder">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-12">
                <div class="picture-actions col-md-6">
                    <div class="col-md-3">
                        <label>Logo</label>
                    </div>

                    <div *ngIf="partner.picturePath" class="col-md-5">
                        <img class="catalog-logo"
                             src="{{partner.picturePath+'?timeupdate='+time}}"/>
                    </div>

                    <div *ngIf="partner.picturePath" class="col-md-4">
                        <label class="btn btn-default" style="margin-bottom: 4px; margin-right: 10px">
                            {{ 'partners.modify' | translate}}
                            <input (change)="partnerPictureFileChange($event)"
                                   type="file" style="display: none;" accept="image/*">
                        </label>

                        <br/>
                        <button class="btn btn-default" (click)="resetPicture($event)">
                            {{ 'partners.delete' | translate}}
                        </button>
                    </div>

                    <div *ngIf="!partner.picturePath" class="col-md-6">
                        <label class="btn btn-default"  style="margin-bottom: 4px; margin-right: 10px">
                            {{ 'partners.picture' | translate}}
                            <input (change)="partnerPictureFileChange($event)"
                                   type="file" style="display: none;" accept="image/*">
                        </label>
                    </div>

                    {{pictureFileError}}
                </div>
            </div>
        </div>

        <div class="row">
            <div style="margin-top:30px;">
                <div class="plt-display-row col-md-12 plt-b-spaced">
                    <h3 style="margin-left: 30px">Publication sur training.zenika.com</h3>
                </div>
                <div class="plt-display-row col-md-12 plt-b-spaced">
                    <div class="col-md-12">
                        <div class="col-md-12">
                            <input
                                type="checkbox"
                                id="publishedUnlisted"
                                [(ngModel)]="partner.publishedUnlisted"
                                name="publishedUnlisted"
                                #name="ngModel"
                            >
                            <label for="publishedUnlisted">
                                Ne pas répertorier.
                                Cocher cette case pour que le partenaire ne puisse pas être trouvé autrement que par lien direct.
                            </label>
                            <label *jhiHasAnyAuthority="'!ROLE_ADMIN'">
                                : {{getBoolTranslateKey(partner.publishedUnlisted) | translate}}
                            </label>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div style="margin:0 30px 15px;">
            <button style="margin-top: 20px;" class="btn btn-primary" type="submit"
                    [disabled]="!updatePartnerForm.valid" name="submit" (click)="save()">Sauvegarder
            </button>
            <button style="margin-top: 20px;" *ngIf="type === 'update'" class="btn btn-default"
                    (click)="showModal(deleteModal)">Supprimer
            </button>
            <a uiSref="partners" uiSrefActive="active">
                <button style="margin-top: 20px;" class="btn btn-default">Retour
                </button>
            </a>
        </div>

        <ng-template #deleteModal>
            <div class="modal-header">
                <h4 class="modal-title">Etes-vous sur de vouloir supprimer ce partenaire?</h4>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-default" (click)="closeModal()">Annuler</button>
                <button type="button" class="btn btn-primary" (click)="removePartner(partner)">Supprimer</button>
            </div>
        </ng-template>
    </form>
</div>



// WEBPACK FOOTER //
// ./src/app/_screens/directory/partner/detail/detail.component.html